export default {
  namespaced: true,
  state: {
    config: {},
    enumsOptions: {},
    requiredAttributes: [],
    optionalAttributes: [],
    requiredDocuments: [],
    optionalDocuments: [],
  },
  mutations: {
    setConfigFields: (state, personKind) => {
      let config = null
      if (state.config && Object.keys(state.config).length > 0) {
        config = state.config.person_kind_configurations.find((item) => item.person_kind === personKind)
      }

      if (!config) {
        state.requiredAttributes = []
        state.optionalAttributes = []
        state.requiredDocuments = []
        state.optionalDocuments = []

        return
      }
      state.requiredAttributes = config.required_attributes
      state.optionalAttributes = config.optional_attributes
      state.requiredDocuments = config.required_documents.map((item) => {
        return {
          document_kind: item,
        }
      })
      state.optionalDocuments = config.optional_documents.map((item) => {
        return {
          document_kind: item,
        }
      })
    },
    setEnumsOptions: (state, payload) => {
      let config = payload
      if (!payload.enums || !Object.keys(payload.enums).length) {
        config = state.config.data.attributes
      }
      const { enums, } = config
      const cities = enums.french_cities_with_state
      const countries = enums.country
      const maritalStatus = enums.marital_status
      const matrimonialRegime = enums.matrimonial_regime
      const pacsConvention = enums.pacs_convention
      const profession = enums.profession
      const professionSector = enums.profession_sector
      const civilities = enums.civility

      const keys = Object.keys(cities)

      const citiesOptions = keys.map((key, index) => {
        return {
          code: key,
          label: `${String(cities[key].dep).padStart(2, '0')} - ${cities[key].libelle}`,
        }
      })

      const countriesOptions = countries.map((item) => {
        return {
          code: item,
          label: item,
        }
      })
      const maritalStatusOptions = maritalStatus.map((item) => {
        return {
          code: item,
          label: payload.$t(`main.enums.marital_status.${item}`),
        }
      })
      const matrimonialRegimeOptions = matrimonialRegime.map((item) => {
        return {
          code: item,
          label: payload.$t(`main.enums.matrimonial_regime.${item}`),
        }
      })
      const pacsConventionOptions = pacsConvention.map((item) => {
        return {
          code: item,
          label: payload.$t(`main.enums.pacs_convention.${item}`),
        }
      })
      const professionOptions = profession.map((item) => {
        return {
          code: item,
          label: item,
        }
      })
      const professionSectorOptions = professionSector.map((item) => {
        return {
          code: item,
          label: item,
        }
      })
      const civilitiesOptions = civilities.map((item) => {
        return {
          key: item,
          label: payload.$t(`main.enums.civility.${item}`),
        }
      })
      state.enumsOptions = {
        civilities: civilitiesOptions,
        cities: citiesOptions,
        countries: countriesOptions,
        maritalStatus: maritalStatusOptions,
        matrimonialRegime: matrimonialRegimeOptions,
        pacsConvention: pacsConventionOptions,
        profession: professionOptions,
        professionSector: professionSectorOptions,
      }
    },
    setCurrentConfig: (state, config) => {
      state.config = config
    },
  },
  getters: {
    enumsOptions: (state) => {
      return state.enumsOptions
    },
    currentConfig: (state) => {
      const config = state.config

      return config
    },
    requiredAttributes: (state) => {
      return state.requiredAttributes
    },
    optionalAttributes: (state) => {
      return state.optionalAttributes
    },
    requiredDocuments: (state) => {
      return state.requiredDocuments
    },
    optionalDocuments: (state) => {
      return state.optionalDocuments
    },
  },
}
